import { createFileRoute } from "@tanstack/react-router";
import { RulesPage } from "@/features/sales/RulesPage";

export const Route = createFileRoute("/_app/sales/rules")({
  component: () => <RulesPage />,
});
